import { createAsyncThunk } from "@reduxjs/toolkit";
import { setGlobalLoading } from "../../../../app/global/slice";
import { ACTION } from "../../../../configs/constants";
import driverFeedbackApi from "./api";

export const doSendFeedback = createAsyncThunk(
  "send-feedback",
  async (payload, thunkAPI) => {
    thunkAPI.dispatch(setGlobalLoading({ isLoading: true, action: ACTION.handle }));
    return driverFeedbackApi.sendFeedback(payload);
  }
);

export const doGetInternalDriverFeedbacks = createAsyncThunk(
  "internal-driver-feedbacks/get/loading",
  async (payload, thunkAPI) => {
    thunkAPI.dispatch(setGlobalLoading({ isLoading: true, action: ACTION.handle }));
    return driverFeedbackApi.getInternalDriverFeedbacks(payload);
  }
);
